import { render, staticRenderFns } from "./Dispatch.vue?vue&type=template&id=1f435b58&"
import script from "./Dispatch.vue?vue&type=script&lang=js&"
export * from "./Dispatch.vue?vue&type=script&lang=js&"
import style0 from "./Dispatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports